import { Input } from '@mui/material';

const DateInput = (props) => (
  <Input
    type="date"
    value={props.item.value || ''}
    onChange={(event) => props.applyValue({ ...props.item, value: event.target.value })}
    style={{ width: '100%' }}
  />
);

const toTime = (value) => {
  if (!value) return null;
  const d = value?.toDate ? value.toDate() : new Date(value);
  const t = d.getTime();
  return Number.isNaN(t) ? null : t;
};

export const getStartDateFilterOperators = (translate) => {
  const t = translate || ((k, opts) => opts?._ || k);
  return [
    {
      label: t('filters.on_or_after', { _: 'On or after' }),
      value: 'onOrAfter',
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.value) return null;
        const min = toTime(`${filterItem.value}T00:00:00`);
        if (min == null) return null;
        return (params) => {
          const time = toTime(params.row?.startdate ?? params.value);
          return time != null && time >= min;
        };
      },
      InputComponent: DateInput,
    },
    {
      label: t('filters.on_or_before', { _: 'On or before' }),
      value: 'onOrBefore',
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.value) return null;
        const max = toTime(`${filterItem.value}T23:59:59.999`);
        if (max == null) return null;
        return (params) => {
          const time = toTime(params.row?.startdate ?? params.value);
          return time != null && time <= max;
        };
      },
      InputComponent: DateInput,
    },
    {
      label: t('filters.is', { _: 'Is' }),
      value: 'is',
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.value) return null;
        const day = String(filterItem.value);
        return (params) => {
          const time = toTime(params.row?.startdate ?? params.value);
          if (time == null) return false;
          const iso = new Date(time).toISOString().slice(0, 10);
          return iso === day;
        };
      },
      InputComponent: DateInput,
    },
  ];
};

const startDateFilterOperators = getStartDateFilterOperators((k, opts) => opts?._ || k);

export default startDateFilterOperators;
